import type { RootState } from '@swf/core/store';
import { Service } from '@swf/core/utils/casinoFilters';
import type { CasinoIcon } from '@swf/generated/types/common/Casino';

import type { CasinoWidgetConfig } from '../types';

export function getIcon() {
  return (rootState: RootState, config: CasinoWidgetConfig) =>
    config.params?.ims.tags[0] as CasinoIcon;
}

export function isFSB() {
  return (rootState: RootState, config: CasinoWidgetConfig) =>
    !!config.gameService.match(Service.FreeSpinBonus);
}
